export default {
  en: {
    title: 'Modify Profile',
    subtitle: 'Modify data of your profile',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Email',
    lang: 'Language',
    password: 'Password',
    confirm: 'Confirm Password',
    errors: {
      firstname: 'Please write a firstname',
      lastname: 'Please write a lastname',
      email: 'Please write a valid email',
      password: 'Write a password with a 6 characters minimum',
      confirm: 'The passwords aren\'t the same.',
      conflict: 'The email it\'s used by other user, please choose other.',
      unknown: 'Something not works, please try again.',
    },
    buttons: {
      password: 'Change password',
      save: 'Save changes',
    },
    passwordSection: {
      title: 'Change Password',
      subtitle: 'Changing your password will close all your sessions.',
    },
    success: {
      user: 'The profile changes was saved successful.',
      password: {
        title: 'The password was changed successful',
        subtitle: 'The active sessions will be closed.',
        successful: 'The password was changed successfully',
      },
    },
  },
  es: {
    title: 'Modificar Perfil',
    subtitle: 'Modique datos de su perfil',
    firstname: 'Nombres',
    lastname: 'Apellidos',
    email: 'Correo electrónico',
    lang: 'Idioma',
    password: 'Contraseña',
    confirm: 'Confirme Contraseña',
    errors: {
      firstname: 'Ingrese un nombre(s) válido',
      lastname: 'Ingrese un apellido(s) válido',
      email: 'Ingrese un email válido',
      password: 'Escriba una contraseña de 6 carácteres mínimo.',
      confirm: 'Las contraseñas no coinciden.',
      conflict: 'El correo electrónico está siendo utilizado por otro usuario, escoja otro.',
      unknown: 'Algo no funciona, intente nuevamente.',
    },
    buttons: {
      password: 'Cambiar contraseña',
      save: 'Guardar Cambios',
    },
    passwordSection: {
      title: 'Cambiar contraseña',
      subtitle: 'Cambiar su contraseña cerrará todas sus sesiones.',
    },
    success: {
      user: 'Los cambios de perfil se guardaron correctamente.',
      password: {
        title: 'La contraseña fue cambiada exitosamente',
        subtitle: 'Las sesiones activas se cerrarán.',
        successful: 'La contraseña fue cambiada exitosamente',
      },
    },
  },
  fr: {
    title: 'Modifier le Profil',
    subtitle: 'Modifier les données de votre profil',
    firstname: 'Prénom',
    lastname: 'Nom',
    email: 'Email',
    lang: 'Langue',
    password: 'Mot de passe',
    confirm: 'Confirmer le Mot de passe',
    errors: {
      firstname: 'Veuillez entrer un prénom',
      lastname: 'Veuillez entrer un nom',
      email: 'Veuillez entrer un email valide',
      password: 'Entrez un mot de passe d\'au moins 6 caractères',
      confirm: 'Les mots de passe ne correspondent pas.',
      conflict: 'L\'email est utilisé par un autre utilisateur, veuillez en choisir un autre.',
      unknown: 'Un problème est survenu, veuillez réessayer.',
    },
    buttons: {
      password: 'Changer le mot de passe',
      save: 'Enregistrer les modifications',
    },
    passwordSection: {
      title: 'Changer le Mot de Passe',
      subtitle: 'Changer votre mot de passe fermera toutes vos sessions.',
    },
    success: {
      user: 'Les modifications du profil ont été enregistrées avec succès.',
      password: {
        title: 'Le mot de passe a été changé avec succès',
        subtitle: 'Les sessions actives seront fermées.',
        successful: 'Le mot de passe a été changé avec succès',
      },
    },
}

};
